export default "__VITE_ASSET__C4rumf$l__"